import { HTTP as http } from "../../http";

const PREFIX = "/questionarios";

export default {
    get: slug => {
        return http.get(PREFIX + "/getBySlug/" + slug);
    },

    getByQuizId: quiz_id => {
        return http.get(PREFIX + "/getByQuizId/" + quiz_id);
    },

    create: data => {
        return http.post(PREFIX + "/create", data);
    }
};
